import { usePageParameterPersistence } from './usePageParameterPersistence';
import { STOWAGE_PARAMS, DEFAULT_STOWAGE_PARAMS, STOWAGE_STORAGE_KEY, STOWAGE_PAGE_PATH } from './stowageNavigationConstants';

/**
 * Pre-configured hook for stowage page parameter persistence
 */
export const useStowageParameterPersistence = () => {
    return usePageParameterPersistence({
        configs: [
            {
                pagePath: STOWAGE_PAGE_PATH,
                parameters: [
                    STOWAGE_PARAMS.STOWAGE_PLAN_GUID,
                    STOWAGE_PARAMS.PORT_CALL_GUID,
                    STOWAGE_PARAMS.BERTH_CALL_GUID,
                    STOWAGE_PARAMS.CARGO_OPERATION_GUID,
                ],
                storageKey: STOWAGE_STORAGE_KEY,
                globalParameters: [...DEFAULT_STOWAGE_PARAMS],
            },
        ],
    });
};
